export default (array, mapKey) =>
  array.sort((a, b) => {
    const keyA = mapKey(a);
    const keyB = mapKey(b);
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
